var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBgLogo = function SvgBgLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "990px",
    height: "565px",
    viewBox: "0 0 990 565",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logos / Altitude Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "6.16297582e-31%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13141E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252839",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "61.926439%",
    y1: "65.4419158%",
    x2: "50%",
    y2: "7.52377125%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191922",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38394D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.2570688%",
    y1: "114.613835%",
    x2: "50%",
    y2: "7.06780187%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A23",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2F41",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warehouse",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login",
    transform: "translate(-462.000000, -576.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logos-/-Altitude-Copy",
    transform: "translate(462.000000, 576.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    fill: "url(#linearGradient-1)",
    points: "0 554.746988 242.250895 116 515 563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5-Copy",
    fill: "url(#linearGradient-2)",
    points: "236 565 546.458426 0 849 565"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5-Copy-2",
    fill: "url(#linearGradient-3)",
    points: "622 565 808.376347 224 990 565"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#37394C",
    points: "545.764246 0 419 229.580987 474.050958 284 558.082438 180.848315 645.555606 256.732094 671 232.75599"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bg-logo.fcdf40829c8d7280bdacb8cdc8d68504.svg";